import { render, staticRenderFns } from "./QuiltyResourcePicturePane.vue?vue&type=template&id=3677786a&"
import script from "./QuiltyResourcePicturePane.vue?vue&type=script&lang=ts&"
export * from "./QuiltyResourcePicturePane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3677786a')) {
      api.createRecord('3677786a', component.options)
    } else {
      api.reload('3677786a', component.options)
    }
    module.hot.accept("./QuiltyResourcePicturePane.vue?vue&type=template&id=3677786a&", function () {
      api.rerender('3677786a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/quiltyResource/QuiltyResourcePicturePane.vue"
export default component.exports